
import {Component, Prop, Vue} from 'vue-property-decorator';
import type {IQueue} from '@pazion/pazion-core/src/models/queue.ts';
import QueueJobState from "@pazion/pazion-core/src/views/queue/components/QueueJobState.vue";

@Component({
  components: {
    QueueJobState
  }
})
export default class TableItemModificator extends Vue {

  @Prop() item!: IQueue

}
